import React from "react";
import Navbar from "../component/Navbar";
import "../css/dashboard.css";
import NoteContent from "./NoteContent";
import { useNavigate } from "react-router-dom";
import { useMediaQuery } from "react-responsive";
import MenuIcon from "@mui/icons-material/Menu";
import { IconButton } from "@mui/material";
import NoteContentMobile from "./NoteContentMobile";

export default function Notes() {
  const navigate = useNavigate();

  const handleMenuOpen = () => {
    navigate("/menumobile");
  };
  const isMobile = useMediaQuery({ query: "(max-width: 800px)" });

  return (
    <div className="main-container">
      {isMobile ? (
        <>
          <div className="menu-button-container">
            <IconButton
              edge="start"
              color="inherit"
              aria-label="menu"
              onClick={handleMenuOpen}
              className="menu-button"
            >
              <MenuIcon />
            </IconButton>
          </div>

          <NoteContentMobile />
        </>
      ) : (
        <>
          <Navbar linkActive={2} />
          <NoteContent />
        </>
      )}
    </div>
  );
}
